import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/contracts/auditTrail/initialState.auditTrail.data';
import { fetchAuditTrail as fetchAuditTrailAPI } from '../../../../apis/contractsAPI';
import { ACTIONS_CONTRACTS } from '../../../../constants/actionCreator';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';

export const fetchAuditTrailData = createAsyncThunkWrapper(
  ACTIONS_CONTRACTS.FETCH_AUDIT_TRAIL,
  fetchAuditTrailAPI
);

const AuditTrailSlice = createSlice({
  name: 'auditTrail',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchAuditTrailData.pending, (state) => {
        state.auditTrailData = [];
        state.auditTrailLoading = true;
      })
      .addCase(fetchAuditTrailData.fulfilled, (state, action) => {
        state.auditTrailData = action?.payload || [];
        state.auditTrailCount = action?.payload?.length || 0;
        state.auditTrailLoading = false;
      })
      .addCase(fetchAuditTrailData.rejected, (state) => {
        state.auditTrailData = [];
        state.auditTrailLoading = false;
      });
  },
});

export const {} = AuditTrailSlice.actions;

export default AuditTrailSlice.reducer;
